
/**
 * Utilitaire pour envoyer des données de formulaire via mailto
 */
export const sendFormByMailto = (
  emailAddress: string,
  subject: string,
  formData: Record<string, any>,
  customTemplate?: (data: Record<string, any>) => string
) => {
  try {
    console.log('Préparation de l\'email avec les données:', formData);
    
    // Construire le corps du message par défaut
    const buildDefaultBody = (data: Record<string, any>) => {
      let body = '';
      
      // Parcourir toutes les données du formulaire
      Object.entries(data).forEach(([key, value]) => {
        if (value) {
          body += `${key}: ${value}\n`;
        }
      });
      
      return body;
    };
    
    // Utiliser le template personnalisé ou par défaut
    const emailBody = customTemplate ? customTemplate(formData) : buildDefaultBody(formData);
    
    // Encoder les paramètres pour le lien mailto
    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
    
    console.log("Ouverture du client de messagerie pour:", emailAddress);
    console.log("Sujet:", subject);
    
    // Ouvrir directement le lien mailto
    window.location.href = mailtoLink;
    
    return true;
  } catch (error) {
    console.error("Erreur lors de l'envoi du formulaire par mailto:", error);
    return false;
  }
};
